import { getLanguage } from '../../appBar/context/LocalizationContext'

const CalculateDate = (value, timezone = undefined) => {
    const currentDate = new Date()
    const postDate = new Date(value)
    const differenceInMilliseconds = currentDate - postDate
    const minutes = Math.floor(differenceInMilliseconds / 1000 / 60)

    const { languageFile } = getLanguage()

    let time = minutes
    const translation = languageFile
    let timeString = ''

    if (time <= 60) {
        timeString = translation.instant
    } else {
        const h = Math.floor(time / 60)

        if (h < 2) {
            timeString = translation.hourFirst + h.toString() + translation.hour
        } else {
            if (h <= 24) {
                timeString = translation.hourFirst + h.toString() + translation.hours
            } else {
                const d = Math.floor(h / 24)

                if (d < 2) {
                    timeString = d.toString() + translation.day
                } else {
                    timeString = d.toString() + translation.days
                }
            }
        }
    }

    return timeString
}

export default CalculateDate

export const parseDate = (dateString) => {
    const date = new Date(dateString)
    const day = date.getDate()
    const month = date.getMonth() + 1
    const year = date.getFullYear()
    return `${day}/${month}/${year}`
}
